import React from 'react';
import { Box, Card, Divider, IconButton, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Input } from '@api/Inputs/Input';
import { InventoryOrderItem } from '@api/InventoryOrders/InventoryOrder';
import { currencyFormatter } from '@utils/Numbers';

interface OrderItem extends InventoryOrderItem {
    id: string;
}

interface InventoryCartListProps {
    orderItems: OrderItem[];
    canModify: boolean;
    onAddItem: (input: Input) => void;
    onRemoveItem: (inputId?: string) => void;
}

export const InventoryCartList: React.FunctionComponent<InventoryCartListProps> = ({
    orderItems,
    canModify,
    onAddItem,
    onRemoveItem
}) => {
    const formatNumber = (value: number | undefined) => {
        if (value === undefined || value < 0) return '000';
        return String(Math.floor(value)).padStart(3, '0');
    };

    return (
        <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
            <Stack spacing={2}>
                {orderItems.map((item) => (
                    <Stack key={item.id}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between" p={1.5}>
                            <Stack>
                                <Typography variant="body1" fontWeight={600}>
                                    {item.input.name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {currencyFormatter(item.input.costOfSale)} c/u
                                </Typography>
                            </Stack>
                            <Stack
                                component={Card}
                                variant="outlined"
                                p={0}
                                direction="row"
                                alignItems="center"
                                spacing={1}
                                sx={{ opacity: canModify ? 1 : 0.5 }}
                            >
                                <IconButton
                                    size="small"
                                    onClick={() => onRemoveItem(item.input.id)}
                                    disabled={!canModify}
                                >
                                    <RemoveIcon fontSize="small" />
                                </IconButton>
                                <Typography>{formatNumber(item.quantity)}</Typography>
                                <IconButton size="small" onClick={() => onAddItem(item.input)} disabled={!canModify}>
                                    <AddIcon fontSize="small" />
                                </IconButton>
                            </Stack>
                        </Stack>
                        <Divider />
                    </Stack>
                ))}
            </Stack>
        </Box>
    );
};

export default InventoryCartList;
